<template>
  <div class="upload-file">
    <b-modal
      id="repInfoRequestDetailModal"
      centered
      size="xl"
      no-close-on-backdrop
      hide-footer
      v-if="row"
    >
      <template #modal-header>
        <div class="repInfoRequestDetailModal-header text-center">
          <h4>Information Change Detail</h4>
          <b-button
            variant="close-btn"
            class="btn-container"
            @click="closeModal"
          >
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="repInfoRequestDetailModal-form">
          <!-- <div class="form-group row">
            <div class="col-lg-6 mb-3">
              <label>Type</label>
              <input type="text" :value="row.type_name" disabled class="custom-field">
            </div>
            <div class="col-lg-6 mb-3">
              <label>Status</label>
            <input type="text" :value="row.status_name" disabled class="custom-field">
            </div>
          </div> -->
          <!-- <div class="form-group mb-3">
            <label>Member</label>
            <input type="text" :value="`${row.user_info.name} - ${row.policy_id}`" disabled class="custom-field">
          </div>
          <div class="form-group mb-3">
            <label>Information</label>
            <input type="text" :value="row.information" disabled class="custom-field">
          </div>
          <div class="form-group mb-3">
            <label>Reason</label>
            <textarea type="text" :value="row.admin_reason" disabled class="custom-field">
            </textarea>
          </div> -->
          <!-- <div class="form-group mb-3">
            <button class="univ-btnEdit">Edit Info</button>
          </div> -->

          <!-- new ui -->
          <div class="repInfoRequestDetailModal-form">
            <div class="info-wrap-req">
              <div class="d-flex align-items-center">
                <div class="mb-0 me-2 info-detail">
                  {{ row.user_info.name }}
                </div>
                <div class="tier-tag">
                  {{ row.type_name }}
                </div>
              </div>
              <div class="info-detail mb-2 pb-1 mt-1">
                System Id : {{ row.policy_id }}
              </div>
              <div class="info-detail">Card Request : {{row.cards_requested}}</div>
              <div
              :class="['status', row.status_name ? row.status_name.toLowerCase().replace(/ /g, '-') : '']"
              >
                {{ row.status_name }}
              </div>
              <div class="row mt-4">
                <div class="col-md-6">
                  <div class="info-detail">Information</div>
                  <div class="">{{ row.information }}</div>
                </div>
                <div class="col-md-6">
                  <div class="info-detail">Reason</div>
                  <div class="">{{ reason }}</div>
                </div>
              </div>
            </div>
            <div class="payment mt-4">
              <div class="info-detail">Payment Details</div>
              <div class="page-card p-0 mt-2 table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>S.N</th>
                      <th>Card Id</th>
                      <th>Payer Id</th>
                      <th>Amount</th>
                      <th>Payment ID</th>
                      <th>Status</th>
                      <th>Description</th>
                      <th>Clearing Date</th>
                      <th>Invoice ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="row.repInfoPaymentDetails && row.repInfoPaymentDetails.length > 0">
                      <tr v-for="(item, index) in row.repInfoPaymentDetails" :key="index">
                        <td>{{++index}}</td>
                        <td>{{item.card_id}}</td>
                        <td>{{item.payer_id}}</td>
                        <td>${{item.amount}}</td>
                        <td>{{item.payment_id}}</td>
                        <td class="text-capitalize">{{item.status}}</td>
                        <td>{{item.payment_description}}</td>
                        <td>{{item.clearing_date}}</td>
                        <td>{{item.invoice_id}}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="9" class="text-center">No records found.</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "RepInfoRequestDetailModal",
  props: {
    row: {
      required: true,
    },
  },
  methods: {
    reset() {
      this.$emit("update:row", null);
    },
    closeModal() {
      this.$bvModal.hide("repInfoRequestDetailModal");
      this.reset();
    },
  },
  computed: {
    reason() {
      return this.row.admin_reason || this.row.cancel_reason;
    },
  },
};
</script>

<style>
.status.completed {
  background: #f3ffeb;
  border: 1px solid #2ca907;
  color: #2ca907;
}

.status.in-progress,
.status.pending {
  color: orange;
  border: 1px solid orange;
  background-color: rgb(255, 243, 222);
}

.status.canceled,
.status.rejected {
  color: red;
  border: 1px solid red;
  background-color: #ffefef;
}

.tier-tag {
  background: #e9fbff;
  color: #04c2f1;
  width: fit-content;
  padding: 0.5rem;
}
.info-detail {
  font-weight: 500;
  color: #000;
}
.repInfoRequestDetailModal-header h4 {
  font-size: 20px;
  color: #2c3f58;
  font-weight: 600;
}
.repInfoRequestDetailModal-header p {
  font-size: 14px;
  color: #2c3f58;
}
.repInfoRequestDetailModal-header button {
  position: absolute;
  top: -15px;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.repInfoRequestDetailModal-form label {
  display: block;
  color: #5e5e5e;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}
.repInfoRequestDetailModal-form .custom-field {
  width: 100%;
  border: 1px solid #dce1e7;
  outline: none;
  border-radius: 6px;
  padding: 9px 15px;
  font-size: 14px;
  transition: all ease 0.6s;
}
.univ-btnEdit,
.univ-btnEdit:focus {
  background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  margin-top: 10px;
  transition: all ease 0.6s;
  box-shadow: inherit;
}
.modal-content {
  border: 0;
  border-radius: 15px;
}
.modal-header {
  justify-content: center;
  border: 0;
  padding: 25px 0;
  position: relative;
}
.repInfoRequestDetailModal-header .btn-container {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.info-wrap-req {
  position: relative;
  background: #f7fafc;
  padding: 0.5rem 1rem 1rem 1rem;
}
.status {
  font-size: 12px;
  padding: 8px 15px;
  border-radius: 50px;
  position: absolute;
  top: -16px;
  right: 18px;
}
</style>
